// Mangia API Configuration
export const MANGIA_API_URL = process.env.NEXT_PUBLIC_MANGIA_API_URL || 'http://localhost:8000';

// API Endpoints
export const MANGIA_API_ENDPOINTS = {
  validation: {
    validate: `${MANGIA_API_URL}/api/v1/validation/validate`,
  },
  stories: {
    getAll: `${MANGIA_API_URL}/api/v1/stories/`,
    getByRestaurant: (restaurantId: string) =>
      `${MANGIA_API_URL}/api/v1/stories/restaurant/${restaurantId}`,
    getByUsername: (username: string) => `${MANGIA_API_URL}/api/v1/stories/username/${username}`,
    getById: (storyId: string) => `${MANGIA_API_URL}/api/v1/stories/${storyId}`,
    create: `${MANGIA_API_URL}/api/v1/stories/`,
    update: (storyId: string) => `${MANGIA_API_URL}/api/v1/stories/${storyId}`,
    updateStatus: (storyId: string) => `${MANGIA_API_URL}/api/v1/stories/${storyId}/status`,
    delete: (storyId: string) => `${MANGIA_API_URL}/api/v1/stories/${storyId}`,
  },
  projects: {
    getBySlug: (slug: string) => `${MANGIA_API_URL}/api/v1/projects/slug/${slug}`,
    getUserProjects: `${MANGIA_API_URL}/api/v1/projects/user/me`,
  },
  // Add more endpoints as needed
} as const;
